module.exports = __webpack_public_path__ + "@/assets/img/repayment-mobile.521901bd.png";